import * as React from "react";

import { Link } from "gatsby";
import Button from "src/components/Button";
import potentialLogoSvg from "src/images/potential-logo.svg";
import vkLogoPng from "src/images/vk-logo.png";
import footerModuleCss from "./footer.module.css";

const Footer = () => {
  return (
    <footer className={`${footerModuleCss.footerContainer} appWithContainer`}>
      <div className={footerModuleCss.potentialLogoWrapper}>
        <a href="https://potential-platform.com/" target="blank">
          <img src={potentialLogoSvg} alt="logo potential" />
        </a>
      </div>
      <div className={footerModuleCss.connectButton}>
        <Link
          to="/connect-form"
          state={{
            modal: true,
            noScroll: true,
            closeTo:
              typeof window !== `undefined` ? window.location.pathname : "/",
          }}
        >
          <Button>СВЯЗАТЬСЯ С НАМИ</Button>
        </Link>
      </div>
      <div className={footerModuleCss.socialLogosContainer}>
        <div>
          <a href="https://vk.com/potential_film" target="blank">
            <img src={vkLogoPng} alt="vk logo" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
